export default __webpack_public_path__ + "static/media/inner-fof-leadership.14ca5479.svg";